import { MapBounds } from "movisat-maps";

export class AmbitoActividadModel {
    marco: MapBounds;
    zonas: number[];

    constructor(marco: MapBounds, zonas: number[]) {
        this.marco = marco;
        this.zonas = zonas;
    }
}